/**
 * Template variable substitution utility
 *
 * Replaces template variables like {{quickstart_fee}} with actual values from businessInfo
 */

/**
 * Substitute template variables in text with actual values
 *
 * Supported variables:
 * - {{quickstart_fee}} - The QuickStart program fee from business info
 *
 * @param {string} text - Text containing template variables
 * @param {object} businessInfo - Business info object with values to substitute
 * @returns {string} Text with variables replaced
 */
export const substituteVariables = (text, businessInfo) => {
  if (!text) return text;

  return text.replace(/\{\{quickstart_fee\}\}/g, businessInfo?.quickstart_fee || '$45');
};

/**
 * Get info text about available template variables
 * Used in admin editors to inform users about variable usage
 */
export const getVariableHelpText = () => {
  return 'Use {{quickstart_fee}} to display the current QuickStart fee dynamically.';
};
